// 利用終了ボタンを表示するかどうか
export const checkIsAbleToFinish = (masterBook, book) => {
  return (
    book.is_valid &&
    !book.is_expired &&
    masterBook.content.description_json.FinishType == "finshButton"
  );
};
